import React, { useState, useCallback, useRef } from 'react';
import { get } from 'lodash';
import useOnClickOutside from '../hooks/useOnClickOutside';
import { OFFERWALL_SORT_OPTIONS } from '../../constants';

export default function OfferwallSort() {
  const [isOpen, setIsOpen] = useState(false);
  const [sortBy, setSortBy] = useState(
    Pollfish.helper.getOfferwallSortProperty(),
  );

  const onOpenFromTouch = useCallback((event) => {
    event.preventDefault();
    setIsOpen(true);
  }, []);

  const onOpenFromClick = useCallback(() => {
    setIsOpen(true);
  }, []);

  const onSelect = useCallback(
    (value) => {
      if (sortBy === value) {
        return;
      }
      setIsOpen(false);
      setSortBy(value);
      Pollfish.helper.setOfferwallSortProperty(value);

      if (!Pollfish.helper.isDebugMode()) {
        Pollfish.analytics.sendMetric({
          metric: 'offerwall-sort-click-monitor',
          deviceId: get(Pollfish, 'helper.json.raw.device_id', null),
          surveyId: null,
          tags: {
            sortBy: value,
            order: Pollfish.helper.getOfferwallSortOrder(),
          },
        });
      }

      Pollfish.offerwallPage.getSurveys();
    },
    [sortBy],
  );

  const onClickOutside = useCallback(() => {
    if (isOpen) {
      setIsOpen(false);
    }
  }, [isOpen]);
  const wrapper = useRef();
  useOnClickOutside(wrapper, onClickOutside);

  return (
    <div ref={wrapper} className="offerwall-sort-container">
      <button
        type="button"
        className="reset-button icon-sorting offerwall-sort-button"
        onClick={onOpenFromClick}
        // in android mobile browser (chrome) there was a delay
        // attaching the click event, so user was clicking
        // the button and do anything, but when we attaching touch
        // event it works without any delay
        onTouchStart={onOpenFromTouch}
        data-testid="offerwall-sort-button"
      />
      <div
        className="offerwall-sort-menu"
        style={{ display: isOpen ? 'block' : 'none' }}
      >
        {OFFERWALL_SORT_OPTIONS.map(({ label, value }) => (
          <button
            key={label}
            type="button"
            className={`reset-button offerwall-sort-menu-option${
              sortBy === value ? ' offerwall-sort-menu-option-selected' : ''
            }`}
            onClick={() => onSelect(value)}
            data-testid="offerwall-sort-menu-option"
          >
            {Pollfish.ui.getText(label)}
          </button>
        ))}
      </div>
    </div>
  );
}
